<template lang="pug">
  .component-home-controller
    .row(v-if="$acl('search-search')")
      .columns
        .action-bar
          .title
            h2 Quick search
        entities-search
    .row(v-if="$acl('_booking')")
      .columns
        .action-bar
          .title
            h2 Quick booking
        book-panel
    .row(v-if="$acl('index-reporting')")
      .columns
        .action-bar
          .title
            h2 Support Requests

        base-list(:component="reportingsComponent", :dataLoader="reportingsDataLoader")
        //paginated-list(:itemComponent="reservationComponent", :type="'shortList'", :data="reservations", :perPage="3", @changePage="loadReservations")
    .row(v-if="$acl('index-reservations')")
      .columns
        .action-bar
          .title
            h2 Reservations

        base-list(:component="component", :dataLoader="reservationDataLoader")
        //paginated-list(:itemComponent="reservationComponent", :type="'shortList'", :data="reservations", :perPage="3", @changePage="loadReservations")

</template>
<script type="text/babel">
  import BookPanel from "components/structure/ui/BookPanel";
  import ReservationListForm from "components/structure/ui/filters/ReservationListForm";
  import KeplerBackofficeSdk from "../../../lib/kepler/backoffice";
  import EntitiesSearch from "../../../components/backoffice/EntitiesSearch";
  import BaseList from "../BaseList";

  export default {
    name: "HomeController",
    components: {
      BaseList,
      EntitiesSearch,
      ReservationListForm,
      BookPanel
    },
    data() {
      return {
        component: require('components/backoffice/Reservation'),
        reportingsComponent: require('src/components/backoffice/Reporting')
      }
    },
    created() {
    },
    methods: {
      reservationDataLoader(callback, page, resultsPerPage, search) {
        KeplerBackofficeSdk.reservations.list(page, 3, {status: 'STARTED'}).all((data) => {
          callback(data)
        })
      },
      reportingsDataLoader(callback, page, resultsPerPage, search) {
        KeplerBackofficeSdk.reportings.list(page, 3, {status: 'PENDING_REVIEW'}).all((data) => {
          callback(data)
        })
      }
    },
    computed: {}
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// Home.vue?1106ce6a